import type { ResolvedTheme } from '@/types/ui';

export function resolveTheme(): ResolvedTheme {
  return 'light';
}
